export const ANCHOCOLUMNA = 300

export const COLORES = ['#285171', '#006f8a', '#00b69b', '#00EEE3', '#14C2EC', '#CBCBCB', '#00000080', '#00000080', '#00000080']